import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { AdminAccountData } from "./AdminAccountData";

const AdminAccount = () => {
  document.title = "Admin Deposit Account Details| mrmto";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title="mrmto"
            breadcrumbItem="Admin Deposit Account Details"
          />
          <AdminAccountData />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AdminAccount;
